import { motion } from "framer-motion";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Standard page frame: a title row with actions, then the content. */
export function Page({ children, className, wide }: { children: ReactNode; className?: string; wide?: boolean }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
      className={cn("mx-auto w-full px-4 pt-5 pb-24 sm:px-6 lg:pb-10", wide ? "max-w-[1600px]" : "max-w-[1320px]", className)}
    >
      {children}
    </motion.div>
  );
}

export function PageHeader({ title, description, actions, eyebrow, className }: { title: ReactNode; description?: ReactNode; actions?: ReactNode; eyebrow?: ReactNode; className?: string }) {
  return (
    <div className={cn("mb-5 flex flex-wrap items-end gap-x-4 gap-y-3", className)}>
      <div className="min-w-[min(100%,18rem)] flex-1">
        {eyebrow && <div className="mb-1 text-[12px] font-medium text-ink-3">{eyebrow}</div>}
        <h1 className="text-[22px] font-semibold tracking-tight text-ink sm:text-[24px]">{title}</h1>
        {description && <p className="mt-1 max-w-2xl text-[13.5px] text-ink-3">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function SectionTitle({ children, action, className }: { children: ReactNode; action?: ReactNode; className?: string }) {
  return (
    <div className={cn("mb-3 flex items-center gap-2", className)}>
      <h2 className="text-[15px] font-semibold text-ink">{children}</h2>
      {action && <div className="ms-auto">{action}</div>}
    </div>
  );
}
